import ScrollLocker from "./ScrollLocker";

export default class SearchController {
    constructor() {
        this.navigation = document.querySelector('.js-navigation');
        this.searchContainer = document.querySelector('.js-search-container');
        this.searchInput = document.querySelector('.js-search-input');
        this.searchBtn = document.querySelector('.js-search-btn');
        this.searchBtnMobile = document.querySelector('.js-search-btn-mobile');
        this.searchOverlay = document.querySelector('.js-search-overlay');

        this.scrollLock = new ScrollLocker();

        if (this.searchContainer && this.searchBtn) {
            this.init();
        }
    }

    init() {
        this.searchBtn.addEventListener('click', () => {
            if (this.searchBtn.classList.contains('is-opened')) {
                this.closeSearch();
                return;
            }

            this.openSearch();
        });

        this.searchBtnMobile.addEventListener('click', () => {
            if (this.searchBtnMobile.classList.contains('is-opened')) {
                this.closeSearch();
                return;
            }

            this.openSearch();
        });

        this.searchOverlay.addEventListener('click', () => {
            if (this.searchBtn.classList.contains('is-opened')) {
                this.closeSearch();
            }
        });

        document.addEventListener("keyup", (ev) => {
            if ((ev.keyCode === 27 || ev.key === "Escape") &&
                this.searchBtn.classList.contains('is-opened')) {
                this.closeSearch();
            }
        });
    }

    closeSearch() {
        this.searchBtn.classList.remove('is-opened');
        this.searchBtnMobile.classList.remove('is-opened');
        this.searchContainer.classList.remove('is-opened');
        this.searchOverlay.classList.remove('is-opened');
        this.navigation.classList.remove('search-opened');

        this.scrollLock.unlockScroll();
    }

    openSearch() {
        this.searchBtn.classList.add('is-opened');
        this.searchBtnMobile.classList.add('is-opened');
        this.searchContainer.classList.add('is-opened');
        this.searchOverlay.classList.add('is-opened');
        this.navigation.classList.add('search-opened');

        this.scrollLock.lockScroll();

        setTimeout(() => {
            this.searchInput.focus();
        }, 500);
    }
}
